import { render, staticRenderFns } from "./DashboardGuarantorAllowrance.vue?vue&type=template&id=7e45f674&scoped=true&"
import script from "./DashboardGuarantorAllowrance.vue?vue&type=script&lang=js&"
export * from "./DashboardGuarantorAllowrance.vue?vue&type=script&lang=js&"
import style0 from "./DashboardGuarantorAllowrance.vue?vue&type=style&index=0&id=7e45f674&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e45f674",
  null
  
)

export default component.exports